import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: "24879968-5efd-49ff-811e-61ea02ab01d1",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: process.env.REACT_APP_REDIRCT_URL,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest: PopupRequest = {
    scopes: [
        "api://dfedbcfe-ab8f-4a13-915c-ea5874197207/SmartAssistantBackendOnBehalfOf"
    ]
};
